export const config = {
  title: 'Quick Submit',
  okText: 'Submit',
  width: 480,
  disabledUntilFilled: true,
  // Source Candidates' "Quick Submit" row action already knows both the job
  // (via popupState.jobId) and the candidate (the selected row) — nothing
  // left to ask, so redirect straight to QuickSubmitForm instead of showing
  // an empty confirm dialog (see quick-submit/api.js's submit()).
  autoSubmitWhenNoFields: true,
  getNote: (context) =>
    context.moduleName === 'candidate'
      ? 'Note: Select a job to submit this candidate'
      : 'Note: Select a candidate to submit for this job',
  getFields: (context) =>
    // Caller already knows the job (e.g. Source Candidates' row action passes
    // { jobId } via searchActionContext) AND the candidate is the selected
    // row — nothing left to ask.
    context.jobId
      ? []
      : context.moduleName === 'candidate'
      ? [
          {
            name: 'jobId',
            label: 'Job list',
            type: 'search-select',
            required: true,
            placeholder: 'Search Job ID/Job name (minimum 3 characters)',
            searchFetchKey: 'quickSubmitJobList',
          },
        ]
      : [
          {
            name: 'candidate',
            label: 'Candidate',
            type: 'search-select',
            required: true,
            placeholder: 'Search candidate name (minimum 3 character)',
            optionsKey: 'candidateOptions',
            searchFetchKey: 'quickSubmitCandidates',
            labelTemplate: '{applicantRefrenceId} - {firstName} {lastName} - ({lastdate})',
            valueKey: '_id',
          },
        ],
};
